import React from 'react'
import QuickRequestRefactor from '../../components/transaction/QuickRequest/QuickRequestRefactor'

const QuickRequestCreation = () => {
  return (
    <div><QuickRequestRefactor context={1}/></div>
  )
}

export default QuickRequestCreation